import * as React from "react";
import { useCallback } from "react";
import { useField } from "formik";
import { InputList } from "components/common";
function FormikInputList({
  field,
  ...props
}) {
  const [_f, _meta, { setValue, setTouched }] = useField({ name: field.name });
  const onChange = useCallback(
    (e) => {
      setTouched(true);
      setValue(e.target.value);
    },
    [setTouched, setValue]
  );
  const onBlur = useCallback(() => {
    setTouched(true);
  }, [setTouched]);
  return /* @__PURE__ */ React.createElement(InputList, { ...props, onChange, onBlur });
}
export default FormikInputList;
